import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Service/defend/RegulatoryCompliance/RegulatoryCompliance.tsx");
